<template>
  <v-form v-model="isFormValid" ref="form">
    <v-row dense>
      <v-col cols="12" md="6">
        <v-text-field :label="$t('profile.company_name')" :rules="requiredRules" v-model="form.name" small dense outlined required :error-messages="fieldErrors.name"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
      <v-text-field class="vat-field" :label="$t('vat_number')" :rules="[taxIdRule]" v-model="form.tax_identifier" small dense outlined :error-messages="fieldErrors.tax_identifier">
          <template v-slot:append-outer>
              <v-menu
                open-on-hover
                close-delay="200"
                :close-on-content-click="false"
                transition="fade-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="vat-info-btn" icon v-bind="attrs" v-on="on">
                    <v-icon color="primary">mdi-information-outline</v-icon>
                  </v-btn>
                </template>
                <div class="custom-tooltip pa-3 black--text body-2" style="max-width: 300px;">
                  <div v-help-center-links v-html="$t('vat_number_help_text', { url: helpCenterUrls[language] ? helpCenterUrls[language] : helpCenterUrls['en'] })"></div>
                </div>
              </v-menu>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>

// import TAX_ID_RULES from '@/const/tax_id_regexp.js'
import { mapGetters } from 'vuex'
import Utils from '@/utils/utils'

export default {
  name: 'BillingBusiness',
  data: () => ({
    isFormValid: false,
    fieldErrors: {},
    form: {
      tax_identifier: '',
      name: ''
    },
    helpCenterUrls: {
      en: 'https://help.scantrust.com/hc/en-us/articles/24123059180188-Wire-Transfer-VAT-TAX-ID-Format',
      de: 'https://help.scantrust.com/hc/de/articles/24123059180188-%C3%9Cberweisung-Format-der-Umsatzsteuer-Identifikationsnummer',
      fr: 'https://help.scantrust.com/hc/fr/articles/24123059180188-Virement-bancaire-Format-de-l-identifiant-TVA-Identifiant-fiscal',
      pt: 'https://help.scantrust.com/hc/pt/articles/24123059180188-Transfer%C3%AAncia-banc%C3%A1ria-Formato-de-IVA-N%C3%BAmero-de-Identifica%C3%A7%C3%A3o-Fiscal',
      es: 'https://help.scantrust.com/hc/es-419/articles/24123059180188-Transferencia-bancaria-Formato-de-IVA-ID-fiscal',
      it: 'https://help.scantrust.com/hc/it/articles/24123059180188-Bonifico-bancario-Formato-partita-IVA-codice-fiscale'
    }
  }),
  computed: {
    ...mapGetters(['language']),
    requiredRules () {
      return [v => !!v || this.$t('field_required')]
    },
    taxIdRule () {
      return v => {
        if (!v) return this.$t('field_required')
        return true
        // Removing tax id regexp for now, we'll just make it required
        // const cleaned = v.replace(/[\s-]/g, '').toUpperCase()
        // const rule = TAX_ID_RULES[this.country]
        // if (rule && rule.test(cleaned)) return true
        // if (!rule && /^[A-Z0-9]{8,14}$/.test(cleaned)) return true
        // if (this.country) {
        //   return this.$t('invalid_tax_id_for_country', { country: this.$t(`countries_${this.country}`) })
        // } else {
        //   return this.$t('invalid_tax_id')
        // }
      }
    }
  },
  props: {
    business: {
      type: Object
    },
    country: {
      type: String
    }
  },
  watch: {
    // country: {
    //   handler () {
    //     this.$nextTick(() => {
    //       if (this.$refs.form && this.form.tax_identifier) {
    //         this.$refs.form.validate()
    //       }
    //     })
    //   },
    //   immediate: true
    // }
    'form.name' () {
      this.clearFieldError('name')
    },
    'form.tax_identifier' () {
      this.clearFieldError('tax_identifier')
    }
  },
  methods: {
    clearFieldErrors () {
      this.fieldErrors = {}
    },
    clearFieldError (fieldName) {
      if (this.fieldErrors[fieldName]) {
        this.$set(this.fieldErrors, fieldName, null)
      }
    },
    setFieldErrors (errors) {
      this.fieldErrors = { ...errors }
    },
    validate () {
      this.clearFieldErrors()
      return this.$refs.form ? this.$refs.form.validate() : this.isFormValid
    },
    async submit () {
      try {
        return await this.$store.dispatch('updateBusiness', { business: this.form })
      } catch (error) {
        if (error.response && error.response.status === 400 && error.response.data) {
          this.setFieldErrors(Utils.parseFieldErrors(error.response.data))
        }
        throw error
      }
    }
  },
  created () {
    this.form = { ...this.business }
  }
}

</script>

<style lang="sass" scoped>

.custom-tooltip
  background: white

::v-deep .vat-field .v-input__append-outer
  margin-top: 3px !important

</style>
